import log from "loglevel";
import { GrandpaSound } from "./grandpaSound";
import { HeartBeatMachineSound } from "./heartBeatMachineSound";
import { HeartBeatSound } from "./heartBeatSound";
import { StateMachine } from "./stateMachine";
export async function run({ elements: { button, heart }, sound, pixiContext, }) {
    log.debug("heart signal interaction start");
    const bouncer = {
        bounceFull(speed) {
            return heart.bounceFull(speed);
        },
        bounceHyper(speed) {
            return heart.bounceHyper(speed);
        },
    };
    const heartBeatMachineSound = new HeartBeatMachineSound(sound);
    heartBeatMachineSound.play();
    const heartBeatSound = new HeartBeatSound(sound);
    heartBeatSound.play();
    const grandpaSound = new GrandpaSound(sound);
    const stateMachine = new StateMachine({ button, bouncer, pixiContext });
    stateMachine.listeners.add(heartBeatMachineSound.stepChangedListener);
    stateMachine.listeners.add(heartBeatSound.stepChangedListener);
    stateMachine.listeners.add(grandpaSound.stepChangedListener);
    await stateMachine.start();
    await stateMachine.dispose();
    heart.dispose();
    heartBeatMachineSound.dispose();
    log.debug("다섯째 인터렉션 끝");
}
//# sourceMappingURL=heartSignalInteraction.js.map